import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';
import { QueryKey, queryKeys } from './queryKeys';
import { useSelector } from 'react-redux';
import { useRouteParams } from '../hooks/useRouteParams';
import { selectCurrentClient } from '../../CommonSelectors/CommonAreaSelector';
import { MESSAGES } from '../../CommonConstants';
import {
  AllocationStrategyData,
  AllocationStrategyType,
  EarmarkValueDTO,
} from '../ManageExcessCashModal.meta';

export const MANAGE_EXCESS_CASH_MK = 'manageExcessCash';

export interface SaveExcessCashParams {
  ExcessCashGoalEarmark: EarmarkValueDTO[] | null;
  ExcessCashAllocationType: AllocationStrategyType;
  ExcessCashAllocationDetails: AllocationStrategyData;
}

const URLS_MAP = {
  ClientSettings: 'Consumer/ClientSettingsUpdate/SaveConsumerExcessCashAllocation',
  MySettings: 'Adviser/Settings/SaveMyExcessCashAllocation',
  FirmSettings: 'Adviser/Settings/SaveFirmExcessCashAllocation',
};

const manageExcessCashOptionsSave = (url: string, clientId?: number) => (
  params: SaveExcessCashParams,
) =>
  authFetch(url, {
    method: 'POST',
    ...httpBodyOptions(
      {
        ...params,
        ...(clientId ? { clientId } : {}),
      },
      true,
    ),
  });

export const useManageExcessCashMutation = () => {
  const currentClient = useSelector(selectCurrentClient);
  const { page } = useRouteParams();

  return useMutation((params: SaveExcessCashParams) => {
    if (currentClient?.Id) {
      return manageExcessCashOptionsSave(URLS_MAP.ClientSettings, currentClient.Id)(params);
    }

    if (page) {
      return manageExcessCashOptionsSave(URLS_MAP[page])(params);
    }

    throw new Error(MESSAGES.GENERIC_ERROR);
  });
};
